export const BASE_URL_API = "https://circular.rxy.com.br/api";
export const SYSTEM_ENV = 1; // 0 debug - 1 produção



// WEBPACK FOOTER //
// ./src/config.js